<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> StandBy Lessons</div>
        </div>
        <hr>
        <div class="box">
            <div class="columns is-multiline">
        
                <div class="column is-6 card" v-for="(property, index) in item" v-if="!['original', 'id', 'status'].includes(index)">
                    <div class="field" >
                        <label class="label">{{snakeToCamelCase(index)}}:</label>
                        <div class="control">
                            <b class="aquamarine">NEW: </b> <span>{{property}}</span>
                            <br><b class="deeppink">OLD: </b> <span>{{item.original[index]}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline">
                <div class="column is-2 is-pulled-right">
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>
                </div>
                <div v-if="item.status == 'requested'" class="column is-2 is-pulled-right">
                    <a class="button is-primary tooltip is-fullwidth" data-tooltip="Approve" @click="approve(item)">
                        <span>Approve</span>
                        <span class="icon" data-tooltip="Approve">
                            <i class="fa fa-check"></i>
                        </span>
                    </a>
                </div>
                <div v-if="item.status == 'requested'" class="column is-2 is-pulled-right">
                    <a class="button is-danger tooltip is-fullwidth" data-tooltip="Decline" @click="decline(item)">
                        <span>Decline</span>
                        <span class="icon" data-tooltip="Decline">
                            <i class="fa fa-times"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'sb-lessons-show',
  components: {},
  data() {
        return {
            item:{original:{}},
        }
  },
  created(){
        this.getLesson(this.$route.params.lesson_id, this.$route.params.id);
  },
  methods: {
    getLesson(lesson_id, id){
        this.stbyLessonRepo.showChanges(lesson_id, id).then(response => {
            this.item = response.data.data;
        });
    },
      approve(item){
          this.stbyLessonRepo.approveChanges(item).then(response => {
              this.$router.push('/dashboard/sb-lesson-changes');
          });
      },
      decline(item){
          this.stbyLessonRepo.declineChanges(item).then(response => {
              this.$router.push('/dashboard/sb-lesson-changes');
          });
      },
  },
  watch: {

  }

}
</script>

<style lang="css" scoped>
    .aquamarine{
        color: aquamarine;
    }
    .deeppink{
        color: deeppink;
    }
    .border{
        border: 1px solid gray;
        border-radius: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/components/sb-lesson-changes/Show.vue